import { convertFromUTCToEST, formatDate, ISO_DATETIME_NO_TZ_FORMAT } from '@/utils/date';

import { formBooleanToFlag, valueToNumber } from './format';

export const overChargeClaimsDetailsSectionLocalToAPI = (data) => {
  return {
    ...data,
    ammendmentDate: data?.ammendmentDate ? convertFromUTCToEST(data?.ammendmentDate) : null,
    bolAttach: formBooleanToFlag(data?.bolAttach),
    checkDateToCustomer: data?.checkDateToCustomer ? convertFromUTCToEST(data?.checkDateToCustomer) : null,
    closedDate: data?.closedDate ? convertFromUTCToEST(data?.closedDate) : null,
    dateSubmitted: data?.dateSubmitted ? convertFromUTCToEST(data?.dateSubmitted) : null,
    fbAttach: formBooleanToFlag(data?.fbAttach),
    invAttach: formBooleanToFlag(data?.invAttach),
    otherAttach: formBooleanToFlag(data?.otherAttach),
  };
};

export const overChargeClaimsNotesSectionLocalToAPI = (data) => {
  return {
    ...data,
    claimComment: data.claimComment
      ? data.claimComment.map((row) => ({
          commentText: row.commentText,
          commentType: row.commentType,
          dirtyFlag: row.dirtyFlag,
          fbOcKey: data.fbOcKey,
          oldCommentType: row.oldCommentType,
          sequenceNo: row.sequenceNo,
        }))
      : [],
  };
};

export const overChargeClaimsItemsSectionLocalToAPI = (data) => {
  return {
    ...data,
    claimItem: data.claimItem
      ? data.claimItem.map((row) => ({
          billedAmount: valueToNumber(row.billedAmount),
          correctCharges: valueToNumber(row.correctCharges),
          dirtyFlag: row.dirtyFlag || 'N',
          fbOcKey: data.fbOcKey,
          invoiceNumber: row.invoiceNumber,
          itemID: row.itemID,
          overchargeAmount: valueToNumber(row.overchargeAmount),
          packageNumber: row.packageNumber,
          paidAmount: valueToNumber(row.paidAmount),
          proNo: row.proNo,
          recoveryAmount: valueToNumber(row.recoveryAmount),
          shipDate: row.shipDate ? formatDate(row.shipDate, ISO_DATETIME_NO_TZ_FORMAT) : null,
          weight: valueToNumber(row.weight),
        }))
      : [],
  };
};

export const overChargeClaimsSettlementsSectionLocalToAPI = (data) => {
  return {
    ...data,
    claimSettlement: data.claimSettlement
      ? data.claimSettlement.map((row) => ({
          accountingCode: row.accountingCode,
          amount: valueToNumber(row.amount),
          dirtyFlag: row.dirtyFlag,
          fbOcKey: data.fbOcKey,
          settlementSeq: row.settlementSeq,
        }))
      : [],
  };
};

export const checkDuplicateOverchargeItem = (items, duplicateValue) => {
  const returnData = { duplicateMessage: '', isHavingDuplicateItem: false };
  if (duplicateValue) {
    const duplicatedItem = items.find(({ proNo, invoiceNumber, packageNumber }) =>
      [String(proNo), String(invoiceNumber), String(packageNumber)].includes(duplicateValue),
    );
    if (duplicatedItem) {
      let duplicatedField = false;

      if (duplicateValue === String(duplicatedItem.proNo)) {
        duplicatedField = 'Freight Bill';
      } else if (duplicateValue === String(duplicatedItem.invoiceNumber)) {
        duplicatedField = 'Invoice Number';
      } else if (duplicateValue === String(duplicatedItem.packageNumber)) {
        duplicatedField = 'Package Number';
      }
      if (duplicatedField) {
        returnData.isHavingDuplicateItem = true;
        returnData.duplicateMessage = `An Overcharge Claim has already been filed for this ${duplicatedField}: ${duplicateValue}`;
      }
    }
  }
  return returnData;
};

export const aggregateOverChargeClaimData = (detailsData, itemsData, notesData, settlementsData) => {
  let formData = overChargeClaimsDetailsSectionLocalToAPI(detailsData);

  formData.claimItem = itemsData;
  formData = overChargeClaimsItemsSectionLocalToAPI(formData);

  formData.claimComment = notesData;
  formData = overChargeClaimsNotesSectionLocalToAPI(formData);

  formData.claimSettlement = settlementsData;
  formData = overChargeClaimsSettlementsSectionLocalToAPI(formData);

  return formData;
};
